import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import {
  useTranslate,
  isOutsideOpenEnrollment,
  getBeneFirstAndLastName,
} from "../../helpers";
import {
  AppPage,
  BeneficiaryInfo,
  DegradedIntegrationAlert,
} from "../../components";
import { AppContext } from "../../app/store";
import { RouteComponentProps, Redirect } from "react-router";
import WhatMedicareCoverage from "../QuestionRoutingPage/WhatMedicareCoverage";
import { useFlags } from "launchdarkly-react-client-sdk";
import routes from "../../app/routes";

const BeneLandingPage: FunctionComponent<RouteComponentProps> = () => {
  const {
    state: { beneficiary, year },
  } = useContext(AppContext);
  const {
    mctYpPublicPreview,
    mctYpOpenEnrollment,
    mctYpOeNextYear,
    mctYpOutsideOpenEnrollment,
    mctCurrentPlanYear,
  } = useFlags();
  const t = useTranslate();
  const outsideOpenEnrollment = isOutsideOpenEnrollment({
    mctYpPublicPreview,
    mctYpOpenEnrollment,
    mctYpOeNextYear,
    mctYpOutsideOpenEnrollment,
  });
  const forNextYear = year === (mctCurrentPlanYear + 1).toString();

  return beneficiary ? (
    <AppPage heading={t("bene_landing.h1")}>
      <div>
        <h2 className="ds-u-color--primary-light ds-u-font-weight--normal e2e-bene-landing-name">
          {getBeneFirstAndLastName(beneficiary, t)}
        </h2>
        <DegradedIntegrationAlert />
        <div className="ds-u-padding--2 ds-u-margin-bottom--4 ds-u-fill--gray-lightest">
          {!outsideOpenEnrollment && forNextYear && (
            <FormattedMessage
              id="bene_landing.review_benefits"
              values={{ year: mctCurrentPlanYear + 1 }}
              tagName="p"
            />
          )}
          <BeneficiaryInfo bene={beneficiary} />
        </div>

        <WhatMedicareCoverage beneficiary={beneficiary} />
      </div>
    </AppPage>
  ) : (
    <Redirect to={routes.questionRouting} />
  );
};

export default BeneLandingPage;
